import { connect } from "react-redux"

import {
    insightAreaListInvalidationRequest,
    insightAreaListSearchRequest,
    insightAreaSetFilter,
    insightAreaAddNew
} from "../../../actions/insight-area-actions"

import InsightAreaListWidget from "./InsightAreaListWidget"

const mapStateToProps = ({
    presentation: { insightAreas },
    paging,
    authentication
}) => ({
    isFetching: insightAreas.isFetchingList || insightAreas.isFetchingItem,
    pagingRequest: paging.topics[insightAreas.searchCriteria] || {},
    nameSearchTerm: insightAreas.workingFilterModel.name,
    isEmptySearchValue: insightAreas.workingFilterModel.empty,
    canAdd: authentication.permissions.indexOf("w_topic") !== -1
})

const mapDispatchToProps = dispatch => ({
    invalidate: pagingRequest => () =>
        dispatch(insightAreaListInvalidationRequest(pagingRequest)),
    onFilterSelect: pagingRequest => () =>
        dispatch(insightAreaSetFilter(true, pagingRequest.searchCriteria)),
    onSearch: ({ target: { name, value, checked } }) =>
        dispatch(
            insightAreaListSearchRequest(
                name,
                name === "empty" ? checked : value
            )
        ),
    onAdd: () => dispatch(insightAreaAddNew())
})

export default connect(mapStateToProps, mapDispatchToProps)(
    InsightAreaListWidget
)
